import { render, staticRenderFns } from "./NavMenuInvitations.vue?vue&type=template&id=ebc1298c&"
import script from "./NavMenuInvitations.vue?vue&type=script&lang=js&"
export * from "./NavMenuInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VIcon,VResponsive})
